export default "__VITE_ASSET__08629793__"